import type { Paginated } from '../types/api';

export function asPage<T>(data: unknown): Paginated<T> {
  if (Array.isArray(data)) {
    return {
      items: data as T[],
      total: data.length,
      page: 1,
      limit: data.length,
      hasMore: false,
    };
  }
  if (data && typeof data === 'object') {
    const rec = data as Record<string, unknown>;
    if (Array.isArray(rec.items)) {
      return {
        items: rec.items as T[],
        total: Number(rec.total ?? rec.items.length),
        page: Number(rec.page ?? 1),
        limit: Number(rec.limit ?? rec.items.length),
        hasMore: Boolean(rec.hasMore),
      };
    }
    if (Array.isArray(rec.data)) {
      return {
        items: rec.data as T[],
        total: Number(rec.total ?? rec.data.length),
        page: Number(rec.page ?? 1),
        limit: Number(rec.limit ?? rec.data.length),
        hasMore: Boolean(rec.hasMore),
      };
    }
  }
  return { items: [], total: 0, page: 1, limit: 20, hasMore: false };
}

export function qs(params: Record<string, string | number | boolean | undefined>): string {
  const search = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === '') continue;
    search.set(k, String(v));
  }
  const s = search.toString();
  return s ? `?${s}` : '';
}
